import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DataManagementService} from '../../services/data-management.service';
import {Constants} from '../../constants';
import {Subject} from 'rxjs';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-round-two',
    templateUrl: './round-two.component.html',
    styleUrls: ['./round-two.component.css']
})
export class RoundTwoComponent implements OnInit {
    @ViewChild('modifyUniversityForRound2') modifyUniversityForRound2: TemplateRef<any>;
    rounds;
    outgoingTerm;
    outgoingTermId;
    selectedOutgoingTerm;
    errorMessage;
    universityWiseStudents;
    givenPreferencesData;
    givenPreferencesDataErrorMessage;
    notGivenPreferencesData;
    notGivenPreferencesDataErrorMessage;
    selectedStudentData;
    universityId;
    initiallyAssignedUniversityId;
    selectedUniversityData;
    showRoundStudentsData: Boolean = false;
    outgoing_round_id;
    public modalReference: NgbModalRef;
    termStudentsData;
    dtTrigger: Subject<string> = new Subject();
    givenPreferencesDtTrigger: Subject<string> = new Subject();
    notGivenPreferencesDtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    givenPreferencesDtOptions: DataTables.Settings = {};
    notGivenPreferencesDtOptions: DataTables.Settings = {};
    tab: any;
    sub;


    constructor(private modal: NgbModal,
                private dmService: DataManagementService,
                private activatedRoute: ActivatedRoute,
                private router: Router) {
    }

    getAllTerms() {
        this.dmService.getAll(Constants.TERM_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.outgoingTerm = response.data.outgoing_terms;
                        for (let i = 0; i < this.outgoingTerm.length; i++) {
                            if (parseInt(this.outgoingTermId, 10) === this.outgoingTerm[i].outgoing_term_id) {
                                this.selectedOutgoingTerm = this.outgoingTerm[i];
                            }
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    routerNavigate(): void {
        this.outgoingTermId = this.selectedOutgoingTerm.outgoing_term_id;
        this.router.navigateByUrl('/navigateRouter', {skipLocationChange: false}).then(() =>
            this.router.navigate(['/bidding-settings-ec/round-two/'], { queryParams: {outgoingTermId: this.outgoingTermId} }));
    }

    getAllRounds(): void {
        this.dmService.getAll(Constants.ROUND_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.rounds = response.data;
                    } else if (response.status === 'fail') {
                        this.errorMessage = response.data.message;
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getUniversityStudents(universityId) {
        if (this.universityWiseStudents.hasOwnProperty(universityId)) {
            return this.universityWiseStudents[universityId].join(', ');
        } else {
            return '-';
        }
    }

    getOutgoingTermStudents() {
        this.errorMessage = undefined;
        this.termStudentsData = undefined;
        this.dmService.javaGetDataCallByParameter(Constants.ROUND2_DATA, this.outgoingTermId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.termStudentsData = response.data;
                        if (this.termStudentsData.length === 0) {
                            this.errorMessage = 'No data available for the selected term.';
                        } else {
                            this.dtTrigger.next();
                        }
                        this.showRoundStudentsData = true;
                    } else if (response.status === 'fail') {
                        this.errorMessage = response.data.message;
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error, Please contact support team.';
                    // this.errorMessage = error;
                });
    }
    getRadioChecked(rowUniversityId) {
        return rowUniversityId === this.universityId;
    }
    changeSelectedUniversity(universityData) {
        this.selectedUniversityData = universityData;
        this.universityId = this.selectedUniversityData.university_id;
    }
    areSeatsAvailable(seats) {
        return parseInt(seats, 10) <= 0;
    }


    openModifyUniversityForStudentModal(data) {
        this.selectedStudentData = data;
        if (this.selectedStudentData.round2_university_id !== 0) {
            this.universityId = this.selectedStudentData.round2_university_id;
        } else if (this.selectedStudentData.round1_university_id !== 0) {
            this.universityId = this.selectedStudentData.round1_university_id;
        }
        this.initiallyAssignedUniversityId = this.universityId;
        // @ts-ignore
        this.modalReference = this.modal.open(this.modifyUniversityForRound2, {size: 'xl',
            windowClass: 'hugeModal',
            backdrop: 'static', keyboard: false
        });
        const parameter = this.selectedStudentData.outgoing_term_id + '/' + this.selectedStudentData.outgoing_student_id;
        this.dmService.javaGetDataCallByParameter(Constants.STUDENT_GIVEN_AND_NOT_GIVEN_PREFERENCES, parameter)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.universityWiseStudents = response.data.university_wise_students;
                        this.givenPreferencesData = response.data.given_preferences_seats_data;
                        if (this.givenPreferencesData.length === 0) {
                            this.givenPreferencesDataErrorMessage = 'No Preferences given in Round I';
                        } else {
                            this.givenPreferencesDtTrigger.next();
                        }
                        this.notGivenPreferencesData = response.data.not_given_preferences_seats_data;
                        if (this.notGivenPreferencesData.length === 0) {
                            this.notGivenPreferencesDataErrorMessage = 'No Preferences given in Round I';
                        } else {
                            this.notGivenPreferencesDtTrigger.next();
                        }
                        this.showRoundStudentsData = true;
                    } else if (response.status === 'fail') {
                        this.errorMessage = response.message;
                        this.givenPreferencesDataErrorMessage = response.message;
                        this.notGivenPreferencesDataErrorMessage = response.message;
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    modifyUniversityForStudent() {
        const body = {
            outgoing_term_id: this.outgoingTermId,
            outgoing_student_id: this.selectedStudentData.outgoing_student_id,
            university_id: this.universityId,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        if (this.initiallyAssignedUniversityId === this.universityId) {
            Swal({
                type: 'warning',
                title: 'Warning',
                html: 'You need to change the university to save changes.'
            });
            return;
        }
        const that = this;
        let modifyUniversityResponse;
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to modify university for student ' + '<span style="font-weight: bold">'
                + this.selectedStudentData.student_name + '</span> to <span style="font-weight: bold">'
                + this.selectedUniversityData.university_name + '</span></p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.MODIFY_ROUND2_UNIVERSITY).subscribe(resData => {
                        modifyUniversityResponse = resData;
                        resolve(modifyUniversityResponse);
                    }, error => {
                        modifyUniversityResponse = error;
                        reject(modifyUniversityResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (modifyUniversityResponse.status === 'success') {
                    that.routerNavigate();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: 'Successfully modified university for student.',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                    that.closeModal();
                } else if (modifyUniversityResponse.status === 'fail') {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Unable to modify university because.' + modifyUniversityResponse.message + '</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        html: '<p>Unable to to modify university, Please contact support team.</p>',
                        showCancelButton: false,
                        showConfirmButton: true,
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                }
            }
        }, function (cancel) {
            console.log(cancel);
        });
    }

    getStudentProcessingDetails(outgoingRoundId) {
        this.showRoundStudentsData = true;
        console.log(this.termStudentsData);
        this.dtTrigger.next();
    }

    closeModal(): void {
        this.universityId = undefined;
        this.givenPreferencesData = undefined;
        this.notGivenPreferencesData = undefined;
        this.modalReference.close();
    }

    selectTab(id) {
        console.log('selected');
        console.log(id);
        this.tab = id;
    }

    activeTab(num) {
        console.log('actived');
        console.log(num);
        return this.tab === num;
    }

    ngOnInit() {
        this.tab = 1;
        this.getAllTerms();
        this.sub = this.activatedRoute
            .queryParams
            .subscribe(params => {
                this.outgoingTermId = params['outgoingTermId'];
            });
        if (this.outgoingTermId !== undefined && this.outgoingTermId !==0 && this.outgoingTermId !== '0') {
            this.getOutgoingTermStudents();
        }
        this.errorMessage = 'Please choose a term.';
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false,
            searching: true
        };
        this.givenPreferencesDtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false,
            searching: true
        };
        this.notGivenPreferencesDtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false,
            searching: true
        };
    }

}
